module.exports = __webpack_public_path__ + "img/pethouse26.87eb3edd.jpg";